<template>
    <div class="chaptering-container h-inherit pointer disable-selection">
        <div class="row no-gutters">
            <div class="col-12 text-center bg-sidebar text-white font-weight-bold">
                MOVE MODE
            </div>

            <SideBarInMoveMode :key="'move-sidebar-lang-' + $i18n.locale"/>

            <Container group-name="chapter" tag="div" class="chapterDropContainer h-100 col-lg-12" lock-axis="y" @drop="onChapterDrop" >
                <loading :active.sync="isLoading"
                         :is-full-page="false"></loading>
                <!-- Chapter -->
                <Draggable v-for="(chapter, cindex) in chapters" :key="chapter.id">

                    <!-- CHAPTER -->
                    <div class="row no-gutters draggable-item">
                        <div class="col-lg-3 col-md-4 col-5 pt-2 br text-center timing-header">
                            <h3>{{ $moment().startOf('day').seconds(chapter.timestamp).format('HH:mm:ss') }}</h3>
                        </div>
                        <div class="col-lg-9 col-md-8 col-7">
                            <h3 class="chapter-header">
                                {{ chapter.title }}
                            </h3>
                        </div>
                    </div>

                    <!-- Entries -->
                    <Container group-name="entries"
                               lock-axis="y"
                               :get-child-payload="(entryIndex) => getChildEntryPayload(entryIndex, chapter)"
                               @drop="(dropResult) => onEntryDrop(dropResult, chapter)"
                               class="entryDropContainer">
                        <Draggable v-for="entry in chapter.entries" :key="entry.id">
                            <div class="row no-gutters draggable-item" :chapterId="chapter.id" :entryId="entry.id" :entryText="entry.text">
                                <!-- Entry Timpestamp -->
                                <div class="col-lg-3 col-md-4 col-5 br text-center timing" :class="getTimingBackgroundColor(entry)">
                                    <span class="">{{ $moment().startOf('day').seconds(entry.timestamp).format('HH:mm:ss') }}</span>
                                </div>

                                <!-- Entry Title -->
                                <div class="col-lg-9 col-md-8 col-7 chapter-entry-container" :class="getEntryBackgroundColor(entry)">
                                <span class="chapter-entry">
                                    {{ entry.text }}
                                </span>
                                </div>
                            </div>
                        </Draggable>
                    </Container>

                </Draggable>
            </Container>
        </div>
    </div>
</template>

<script>
import { Draggable, Container } from 'vue-smooth-dnd';
import Loading from 'vue-loading-overlay';
import SideBarInMoveMode from '../../Sidebar/MoveMode/SidebarInMoveMode';

import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';


const ChapterRepository = RepositoryFactory.get('chapters');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'ChapterEntryListInMoveMode',
  components: {
    SideBarInMoveMode, Draggable, Container, Loading,
  },
  props: ['chapters'],
  data() {
    return {
      isLoading: false,

      sourceChapter: null,
      targetChapter: null,
      movingEntry: null,
    };
  },
  methods: {
    /*
        ENTRY MOVE
      */
	  getChildEntryPayload(index, chapter) {
	  	// Return the Entry matching the index & chapter
	  	return chapter.entries.find(c => c.order === index);
	  },
    async onEntryDrop(dropResult, chapter) {
	    const { removedIndex, addedIndex, payload } = dropResult;

      // Don't launch a request when the order hasn't changed.
      if (removedIndex === addedIndex) { return false; }

      if (removedIndex !== null) {
      	// This is the source container
	      this.sourceChapter = chapter;
      }
      if (addedIndex !== null) {
      	// this is the target container
	      this.targetChapter = chapter;
	      this.targetPosition = addedIndex;
      }

      // if source & Target Chapter are set
      if (this.sourceChapter !== null && this.targetChapter !== null) {
      	// Check the Payload. Payload should contain the entry object being moved.
      	if (payload !== undefined && payload !== null) {
		      this.movingEntry = payload;

		      this.isLoading = true;
		      await ChapterRepository.move(this.sourceChapter.id, this.movingEntry.id, this.targetChapter.id, this.targetPosition).then((res) => {
			      InstanceRepository.refetchActive(false).finally(r => this.isLoading = false);
		      });

		      // Reset Selections
		      this.sourceChapter = null;
		      this.targetChapter = null;
		      this.movingEntry = null;
		      this.targetPosition = null;
        }
      }
    },


    /*
        CHAPTER MOVE
       */
    getChapterByIndex(index) {
      return this.chapters[index];
    },
    async onChapterDrop(dropResult) {
      const { removedIndex, addedIndex } = dropResult;

      // Don't launch a request when the order hasn't changed.
      if (removedIndex === addedIndex) { return false; }

      this.isLoading = true;
      const oldPosChapter = this.getChapterByIndex(removedIndex - 1);

      await ChapterRepository.move(oldPosChapter.id, null, null, addedIndex - 1).then((res) => {
        InstanceRepository.refetchActive(false).finally(r => this.isLoading = false);
      });
    },
    getEntryBackgroundColor(entry) {
      return entry.order % 2 ? 'entry-grey' : '';
    },
    getTimingBackgroundColor(entry) {
      return entry.order % 2 ? 'timing-grey' : '';
    },
  },
};
</script>

<style>
  .entryDropContainer {
    background: #e5e5e5;
    border-top: 3px dashed #aaa1a1;
    border-bottom: 3px dashed #aaa1a1;
    min-height: 25px;
  }
</style>
